import { defineStore } from 'pinia'

export const useRegisterStore = defineStore('register', {
  state: () => ({
    phone: '',
    countryCode: '+62',
    email: '',
    fullname: '',
    otpToken: '',
    pin: '',
    confirmPin: ''
  }),
  getters: {},
  actions: {
    setRegisterData(
      payload: Partial<{
        phone: string
        countryCode: string
        email: string
        fullname: string
        otpToken: string
        pin: string
        confirmPin: string
      }>
    ) {
      if (payload.phone !== undefined) this.phone = payload.phone
      if (payload.countryCode !== undefined)
        this.countryCode = payload.countryCode
      if (payload.email !== undefined) this.email = payload.email
      if (payload.fullname !== undefined) this.fullname = payload.fullname
      if (payload.otpToken !== undefined) this.otpToken = payload.otpToken
      if (payload.pin !== undefined) this.pin = payload.pin
      if (payload.confirmPin !== undefined) this.confirmPin = payload.confirmPin
    },
    resetRegisterData() {
      this.phone = ''
      this.countryCode = '+62'
      this.email = ''
      this.fullname = ''
      this.otpToken = ''
      this.pin = ''
      this.confirmPin = ''
    }
  }
})
